import { destroy, invalidator, create } from '@dojo/framework/core/vdom';
import injector from '@dojo/framework/core/middleware/injector';
const factory = create({ destroy, invalidator, injector });
export const createStoreMiddleware = (statename = 'state', initial) => {
    let store;
    let initialized = false;
    const storeMiddleware = factory(({ middleware: { destroy, invalidator, injector } }) => {
        const handles = [];
        destroy(() => {
            let handle;
            while ((handle = handles.pop())) {
                handle();
            }
        });
        if (!initialized) {
            const injectedStore = injector.get(statename);
            if (injectedStore) {
                store = injectedStore;
            }
            initial && initial(store);
            initialized = true;
        }
        const registeredPaths = [];
        const path = (path, ...segments) => {
            return store.path(path, ...segments);
        };
        const api = {};
        api.getStore = () => store;
        api.setStore = (storeval) => {
            if (store && storeval !== store) {
                let handle;
                while ((handle = handles.pop())) {
                    handle();
                }
            }
            store = storeval;
        };
        api.get = (path, dontWatch = false) => {
            if (!dontWatch && registeredPaths.indexOf(path.path) === -1) {
                const handle = store.onChange(path, () => {
                    invalidator();
                });
                handles.push(() => handle.remove());
                registeredPaths.push(path.path);
            }
            return store.get(path);
        };
        api.path = path;
        api.at = (path, index) => store.at(path, index);
        api.executor = (process) => process(store);
        api.run = api.executor;
        return api;
    });
    return storeMiddleware;
};
